import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/ratesConstants';

const initialState = {
  rates: [],
  rate: null,
  loading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const ratesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_RATES:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_RATE:
      return {
        ...state,
        rate: null,
      };
    case types.GET_RATES_SUCCESS:
      return {
        ...state,
        loading: false,
        rates: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_RATES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_RATES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_RATE:
      return {
        ...state,
        rate: payload,
      };
    case types.SET_RATES_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_RATES_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_RATES_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_RATES_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default ratesReducer;
